/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    V1LabelSelector,
    V1LabelSelectorFromJSON,
    V1LabelSelectorFromJSONTyped,
    V1LabelSelectorToJSON,
} from './V1LabelSelector';
import {
    V1TypedLocalObjectReference,
    V1TypedLocalObjectReferenceFromJSON,
    V1TypedLocalObjectReferenceFromJSONTyped,
    V1TypedLocalObjectReferenceToJSON,
} from './V1TypedLocalObjectReference';
import {
    V1TypedObjectReference,
    V1TypedObjectReferenceFromJSON,
    V1TypedObjectReferenceFromJSONTyped,
    V1TypedObjectReferenceToJSON,
} from './V1TypedObjectReference';
import {
    V1VolumeResourceRequirements,
    V1VolumeResourceRequirementsFromJSON,
    V1VolumeResourceRequirementsFromJSONTyped,
    V1VolumeResourceRequirementsToJSON,
} from './V1VolumeResourceRequirements';

/**
 * PersistentVolumeClaimSpec describes the common attributes of storage devices
 * and allows a Source for provider-specific attributes
 * @export
 * @interface V1PersistentVolumeClaimSpec
 */
export interface V1PersistentVolumeClaimSpec {
    /**
     * accessModes contains the desired access modes the volume should have.
     * More info: https://kubernetes.io/docs/concepts/storage/persistent-volumes#access-modes-1
     * +optional
     * +listType=atomic
     * @type {Array<string>}
     * @memberof V1PersistentVolumeClaimSpec
     */
    accessModes?: Array<string>;
    /**
     * 
     * @type {V1TypedLocalObjectReference}
     * @memberof V1PersistentVolumeClaimSpec
     */
    dataSource?: V1TypedLocalObjectReference;
    /**
     * 
     * @type {V1TypedObjectReference}
     * @memberof V1PersistentVolumeClaimSpec
     */
    dataSourceRef?: V1TypedObjectReference;
    /**
     * 
     * @type {V1VolumeResourceRequirements}
     * @memberof V1PersistentVolumeClaimSpec
     */
    resources?: V1VolumeResourceRequirements;
    /**
     * 
     * @type {V1LabelSelector}
     * @memberof V1PersistentVolumeClaimSpec
     */
    selector?: V1LabelSelector;
    /**
     * storageClassName is the name of the StorageClass required by the claim.
     * More info: https://kubernetes.io/docs/concepts/storage/persistent-volumes#class-1
     * +optional
     * @type {string}
     * @memberof V1PersistentVolumeClaimSpec
     */
    storageClassName?: string;
    /**
     * volumeAttributesClassName may be used to set the VolumeAttributesClass used by this claim.
     * If specified, the CSI driver will create or update the volume with the attributes defined
     * in the corresponding VolumeAttributesClass. This has a different purpose than storageClassName,
     * it can be changed after the claim is created. An empty string value means that no VolumeAttributesClass
     * will be applied to the claim but it's not allowed to reset this field to empty string once it is set.
     * If unspecified and the PersistentVolumeClaim is unbound, the default VolumeAttributesClass
     * will be set by the persistentvolume controller if it exists.
     * If the resource referred to by volumeAttributesClass does not exist, this PersistentVolumeClaim will be
     * set to a Pending state, as reflected by the modifyVolumeStatus field, until such as a resource
     * exists.
     * More info: https://kubernetes.io/docs/concepts/storage/volume-attributes-classes/
     * (Beta) Using this field requires the VolumeAttributesClass feature gate to be enabled (off by default).
     * +featureGate=VolumeAttributesClass
     * +optional
     * @type {string}
     * @memberof V1PersistentVolumeClaimSpec
     */
    volumeAttributesClassName?: string;
    /**
     * +enum
     * @type {string}
     * @memberof V1PersistentVolumeClaimSpec
     */
    volumeMode?: string;
    /**
     * volumeName is the binding reference to the PersistentVolume backing this claim.
     * +optional
     * @type {string}
     * @memberof V1PersistentVolumeClaimSpec
     */
    volumeName?: string;
}

export function V1PersistentVolumeClaimSpecFromJSON(json: any): V1PersistentVolumeClaimSpec {
    return V1PersistentVolumeClaimSpecFromJSONTyped(json, false);
}

export function V1PersistentVolumeClaimSpecFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1PersistentVolumeClaimSpec {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accessModes': !exists(json, 'accessModes') ? undefined : json['accessModes'],
        'dataSource': !exists(json, 'dataSource') ? undefined : V1TypedLocalObjectReferenceFromJSON(json['dataSource']),
        'dataSourceRef': !exists(json, 'dataSourceRef') ? undefined : V1TypedObjectReferenceFromJSON(json['dataSourceRef']),
        'resources': !exists(json, 'resources') ? undefined : V1VolumeResourceRequirementsFromJSON(json['resources']),
        'selector': !exists(json, 'selector') ? undefined : V1LabelSelectorFromJSON(json['selector']),
        'storageClassName': !exists(json, 'storageClassName') ? undefined : json['storageClassName'],
        'volumeAttributesClassName': !exists(json, 'volumeAttributesClassName') ? undefined : json['volumeAttributesClassName'],
        'volumeMode': !exists(json, 'volumeMode') ? undefined : json['volumeMode'],
        'volumeName': !exists(json, 'volumeName') ? undefined : json['volumeName'],
    };
}

export function V1PersistentVolumeClaimSpecToJSON(value?: V1PersistentVolumeClaimSpec | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accessModes': value.accessModes,
        'dataSource': V1TypedLocalObjectReferenceToJSON(value.dataSource),
        'dataSourceRef': V1TypedObjectReferenceToJSON(value.dataSourceRef),
        'resources': V1VolumeResourceRequirementsToJSON(value.resources),
        'selector': V1LabelSelectorToJSON(value.selector),
        'storageClassName': value.storageClassName,
        'volumeAttributesClassName': value.volumeAttributesClassName,
        'volumeMode': value.volumeMode,
        'volumeName': value.volumeName,
    };
}

